import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PromiseResult } from '../models/PromiseResult';
import { getDoctorReferal } from '../models/Doctorreferral';
import { doctor_register_api_data } from '../models/doctorregistration';
import { OTP_Validate } from '../models/util.models';

@Injectable({
    providedIn: 'root'
})
export class DoctorReferralService {
    constructor(private readonly http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    getNewDoctorReferrals(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.ReferralApi + 'Get/New')
            .pipe(catchError(this.handleError));
    }

    UpdatestatusDoctorReferrals(
        action_id: number,
        user_guid: string
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.ReferralApi + 'Update/Status/' + user_guid,
                { action_id: action_id }
            )
            .pipe(catchError(this.handleError));
    }

    getPendingDoctorReferrals(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.ReferralApi + 'Get/Pending')
            .pipe(catchError(this.handleError));
        //return of (DOCTORS);
    }

    getApprovedDoctorReferrals(): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.ReferralApi + 'Get/Approved')
            .pipe(catchError(this.handleError));
    }

    CreateDoctor(
        // doctorData: doctor_register_api_data
        doctorData: FormData
    ): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.ReferralApi + 'Doctor/Create',
                doctorData
            )
            .pipe(catchError(this.handleError));
    }

    photoUpload(form: FormData, user_guid: string): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.ReferralApi +
                'Doctor/Update/ProfilePhoto/' +
                user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }

    resumeUpload(form: FormData, user_guid: string): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.ReferralApi +
                'Doctor/Profile/Update/Resume/' +
                user_guid,
                form
            )
            .pipe(catchError(this.handleError));
    }

    signAgreement(form: FormData): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.ReferralApi + 'Doctor/Agreement',
                form
            )
            .pipe(catchError(this.handleError));
    }

    getReferralDoctorsProfile(
        data: getDoctorReferal
    ): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.ReferralApi + 'Doctor/Profile/fetch/',
                data
            )
            .pipe(catchError(this.handleError));
    }

    getProfileData(data: {
        referral_doctor_guid: string;
        d_email: string;
    }): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.ReferralApi + 'Doctor/Referral/Fetch',
                data
            )
            .pipe(catchError(this.handleError));
    }

    register_doctor_validate_or_resend_otp(data: OTP_Validate) {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.ReferralApi +
                'validate',
                data
            )
            .pipe(catchError(this.handleError));
    }
}
